export const home = {
  // Hero section
  "hero.title": "Trouvez les meilleurs fournisseurs au Nigeria",
  "hero.subtitle": "Découvrez et contactez directement des entreprises selon vos critères.",
  "hero.search_placeholder": "Recherche des produits, services ou entreprises",
  "hero.location_placeholder": "Votre localisation",
  "hero.cta": "Rechercher maintenant",
  "hero.badge_trusted": "Accédez à plus de {{count, number}} entreprises nigérianes",

  // Stats section
  "stats.suppliers": "Fournisseurs",
  "stats.categories": "Catégories",
  "stats.cities": "Villes",
  "stats.reviews": "Avis",
  "stats.states": "États",
  "stats.transactions": "Transactions",
  "stats.rating": "Note",

  // Categories section
  "categories.title": "Catégories populaires",
  "categories.subtitle": "Explorez nos principales catégories d'entreprises",
  "categories.view_all": "Voir toutes les catégories",

  // Premium section
  "premium.title": "Fournisseurs Premium",
  "premium.subtitle": "Découvrez nos fournisseurs premium vérifiés",
  "premium.verified": "Vérifié",
  "premium.view_profile": "Voir le profil",
  "premium.no_businesses": "Aucun fournisseur premium",
  "premium.no_businesses_desc": "Il n'y a actuellement aucun fournisseur premium. Revenez plus tard !",
  "premium.no_suppliers": "Aucun fournisseur premium",
  "premium.no_suppliers_desc": "Il n'y a actuellement aucun fournisseur premium. Revenez plus tard !",
  "premium.verified_badge": "Vérifié",
  "premium.view_details": "Voir détails",
  "premium.retry": "Réessayer",
  "premium.contact": "Contact",
  "premium.full_address_available": "Adresse complète disponible",

  // How it works
  "how.title": "Comment ça marche",
  "how.step1.title": "Recherchez",
  "how.step1.desc": "Trouvez des entreprises par catégorie ou localisation",
  "how.step2.title": "Comparez",
  "how.step2.desc": "Consultez les avis et évaluations",
  "how.step3.title": "Contactez",
  "how.step3.desc": "Entrez en contact directement",

  // CTA section
  "cta.title": "Vous êtes un fournisseur ?",
  "cta.subtitle": "Rejoignez notre plateforme et développez votre activité",
  "cta.button": "Créer un compte fournisseur",

  // Newsletter section
  "newsletter.title": "Restez informé",
  "newsletter.stay_informed": "Restez informé",
  "newsletter.subtitle": "Abonnez-vous à notre newsletter pour recevoir les dernières actualités",
  "newsletter.benefit1": "Recevez des offres exclusives",
  "newsletter.benefit2": "Découvrez de nouveaux fournisseurs",
  "newsletter.benefit3": "Restez à jour avec les dernières tendances",
  "newsletter.name_placeholder": "Votre nom complet",
  "newsletter.email_placeholder": "votre@email.com",
  "newsletter.sector": "Secteur d'activité",
  "newsletter.select_sector": "Sélectionnez votre secteur",
  "newsletter.sector_placeholder": "Sélectionnez votre secteur",
  "newsletter.form_title": "Inscription à la newsletter",
  "newsletter.description": "Recevez les dernières actualités sur les fournisseurs, les nouvelles entreprises et les opportunités d'affaires au Nigeria.",
  "newsletter.full_name": "Nom complet",
  "newsletter.submitting": "Inscription en cours...",
  "newsletter.success_title": "Inscription réussie !",
  "newsletter.success_message": "Merci de vous être abonné à notre newsletter. Un email de confirmation vous a été envoyé.",
  "newsletter.already_subscribed": "Vous êtes déjà inscrit à notre newsletter.",
  "newsletter.error_title": "Erreur",
  "newsletter.error_message": "Erreur lors de l'inscription. Veuillez réessayer.",
  "newsletter.subscribe_button": "S'abonner à la newsletter",
  "contact.title": "Vous êtes fournisseur ?",
  "contact.subtitle": "Rejoignez des milliers de fournisseurs et développez votre activité",
  "contact.register_free": "Inscrire mon entreprise gratuitement",
  "contact.talk_advisor": "Parler à un conseiller",
  "contact.modal.title": "Parler à un conseiller",
  "contact.modal.subtitle": "Olufona est là pour vous aider",
  "contact.modal.email": "Email",
  "contact.modal.whatsapp": "WhatsApp",
  "contact.modal.message": "Message",
  "contact.modal.internal_message": "Messagerie interne",
  "contact.modal.back": "Retour",
  "contact.modal.send_message": "Envoyer un message à Olufona",
  "contact.modal.sent_title": "Message envoyé !",
  "contact.modal.sent_message": "Nous vous répondrons dans les plus brefs délais.",
  "contact.modal.placeholder": "Écrivez votre message ici...",
  "contact.modal.sending": "Envoi en cours...",
  "contact.modal.send_button": "Envoyer le message",
  // Stats section - additional labels
  "stats.product_categories": "Catégories de produits",
  "stats.monthly_searches": "Recherches mensuelles",
  "stats.loading": "Chargement des fournisseurs...",
  "stats.loading_slow": "Le chargement prend plus de temps que prévu",
  "stats.retry": "Réessayer",

  // Featured/Premium section - additional
  "featured.title": "Fournisseurs en vedette",
  "featured.subtitle": "Découvrez les fournisseurs les mieux notés près de chez vous",
  "featured.verified": "Vérifié",
  "featured.contact": "Contact",
  "featured.view_details": "Voir détails",

  // Search tabs (home page)
  "search.tabs.products": "Produits",
  "search.tabs.suppliers": "Fournisseurs"
};

export default home;